import { Component, Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { StepActions } from './step-actions';
import { DispatcherModule } from '../dispatcher.module';
import { AppState } from '../state.model';

@Injectable({
  providedIn: DispatcherModule
})
export class StepDispatcher {
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  setNextStep(step: string) {
    this.ngRedux.dispatch(StepActions.setNext(step));
  }
  setError(error: string) {
    this.ngRedux.dispatch(StepActions.setError(error));
  }
  setIsMobile(value: boolean) {
    this.ngRedux.dispatch(StepActions.setIsMobile(value));
  }
  storeGuid(value: boolean) {
    this.ngRedux.dispatch(StepActions.storeGuid(value));
  }
  storeGuidValue(value: string) {
    this.ngRedux.dispatch(StepActions.storeGuidValue(value));
  }
  storeVin(value: boolean) {
    this.ngRedux.dispatch(StepActions.storeVin(value));
  }
  isVehicleAssociated(details) {
    this.ngRedux.dispatch(StepActions.isVehicleAssociated(details));
  }
}
